import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { TituloReceberClienteTableComponent } from './titulo-receber-cliente-table.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberClienteTableComponent
    ],
    exports: [
        TituloReceberClienteTableComponent
    ]
})
export class TituloReceberClienteTableModule { }
